// Expense statuses, as stored. The labels differ deliberately: the stored value
// for a submitted expense awaiting a decision is 'pending', but an employee
// reading their own list cares whether they still have something to do, so the
// badge calls that one "Submitted" and calls a draft "Not submitted". See
// server/sql/expense_draft_status_schema.sql for why the stored values were
// left alone. ExpenseStatusBadge owns the labels; these are the predicates.

export const EXPENSE_STATUS = {
  DRAFT: 'draft',
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

export const normalizeExpenseStatus = (value) => String(value || '').trim().toLowerCase();

// Saved but never sent — finance has never seen it.
export const isDraftExpense = (expense) =>
  normalizeExpenseStatus(expense?.status) === EXPENSE_STATUS.DRAFT;

// Sent and waiting on a decision.
export const isPendingExpense = (expense) =>
  normalizeExpenseStatus(expense?.status) === EXPENSE_STATUS.PENDING;

// Nobody has decided it yet, so it is still the employee's to change: edit it,
// move it between groups, delete it, submit it.
export const isOpenExpense = (expense) => isDraftExpense(expense) || isPendingExpense(expense);
